import axios from 'axios'

const state = {
    bailiffs: [],
    applications: []
};

const actions = {
    getAllBailiffs ({commit}) {
        axios.post('api/bailiff/get-bailiffs').then(
            response => {
                commit('recieve_bailiffs', response.data.data)
            }
        ).catch(errors =>{
            console.log(errors);
        })
    },
    getAllApplications ({commit}) {
        axios.post('api/contracts-case/get-applications').then(
          response => {
              commit('recieve_applications', response.data.applications)
          }
        ).catch(errors =>{
            console.log(errors);
        })
    },
};

const mutations = {
    recieve_bailiffs (state, bailiffs) {
        state.bailiffs = bailiffs;
    },
    recieve_applications (state, applications) {
        state.applications = applications;
    },
};

const getters = {
    allBailiffs (state) {
        return state.bailiffs
    },
    allApplications (state) {
        return state.applications
    }
};

export default {
    state,
    actions,
    mutations,
    getters
}
